<template>
  <modal v-model="value.show">
    <div slot="content">
      <form @submit.prevent="validateBeforeSubmit">
        <div class="ls-modal-header">
          <button type="button" close-modal data-dismiss="modal">&times;</button>
          <h4 class="ls-modal-title">{{ $t('contracts.send_payment_url.title') }}</h4>
        </div>

        <div class="ls-modal-body">
          {{ $t('invoices.labels.send_email_information') }}
        </div>
        <div class="ls-modal-footer">
          <button type="button" class="ls-btn" close-modal data-dismiss="modal">{{ $t('application.button.close') }}</button>
          <a @click="sendEmail()" class="ls-btn ls-btn-primary ls-float-right">{{ $t('application.button.confirm') }}</a>
        </div>
      </form>
    </div>
  </modal>
</template>
<script type="text/javascript">
  import { mapActions, mapGetters } from 'vuex'
  import Modal from 'src/app/components/shareds/modal/Modal'
  import date from 'src/utils/date'
  import scroll from 'src/utils/scroll'

  export default {
    props: ['value'],
    components: { Modal },
    computed: {
      ...mapGetters(['invoice', 'invoices', 'contract'])
    },
    methods: {
      ...mapActions(['regenerateOrder']),
      sendEmail () {
        this.value.show = false
        this.$loader.show()
        const params = { contract_id: this.invoice.contract_id, id: this.invoice.id }
        this.regenerateOrder(params).then(this.afterRegenerateOrder)
      },
      afterRegenerateOrder (response) {
        if (response && response.status === 200) {
          this.$parent.getInvoice()
          this.afterSend()
        } else {
          scroll.scrollToFlash()
          this.$loader.hide()
        }
      },
      afterSend () {
        this.$loader.hide()
        scroll.scrollToFlash()
      }
    },
    watch: {
      invoice () {
        var dueDate = date.parseInternationalDate(this.invoice.due_date)
        var dateCurrent = date.parseInternationalDate(new Date())

        if (dateCurrent > dueDate) {
          this.anotherDueDate = dateCurrent
        } else {
          this.anotherDueDate = dueDate
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalSendPayment.vue?41043751